import { render, staticRenderFns } from "./TheOracleAccountDetails.vue?vue&type=template&id=a13f24fc&"
import script from "./TheOracleAccountDetails.vue?vue&type=script&lang=js&"
export * from "./TheOracleAccountDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports